import styled from 'styled-components'

export const PromptRoot = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(14px, 4vw, 36px);
  background:
    radial-gradient(circle at 50% 0%, ${p => p.theme.palette.colors.shellGradientStart} 0%, transparent 52%),
    ${p => p.theme.palette.colors.background};
  color: ${p => p.theme.palette.colors.text};
  animation: surveyPromptReveal 0.32s ease both;

  @keyframes surveyPromptReveal {
    from {
      opacity: 0;
      transform: scale(1.015);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`

export const PromptInner = styled.div`
  width: min(560px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
`

export const PromptBadge = styled.span`
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 4px 11px;
  border: 1px solid ${p => p.theme.palette.blue.main};
  border-radius: 999px;
  background: ${p => p.theme.palette.colors.badgeMuted};
  color: ${p => p.theme.palette.blue.main};
  font-family: Poppins;
  font-size: 11px;
  font-weight: 700;
`

export const PromptEyebrow = styled.div`
  max-width: 100%;
  overflow: hidden;
  color: ${p => p.theme.palette.colors.subdued};
  font-family: Lato;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const PromptTitle = styled.h2`
  margin: 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: clamp(22px, 3.2vw, 34px);
  font-weight: 700;
  line-height: 1.08;
  letter-spacing: -0.025em;
`

export const PromptCountdown = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
`

export const PromptCountdownValue = styled.span`
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${p => p.theme.palette.blue.main};
  border-radius: 50%;
  background: ${p => p.theme.palette.colors.badgeMuted};
  color: ${p => p.theme.palette.blue.main};
  font-family: Poppins;
  font-size: 14px;
  font-weight: 800;
`

export const PromptCountdownCopy = styled.span`
  color: ${p => p.theme.palette.colors.muted};
  font-family: Lato;
  font-size: 13px;
  font-weight: 500;
`

export const PromptActions = styled.div`
  width: min(390px, 100%);
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 4px;

  .MuiButton-root {
    min-width: 0;
    padding-inline: 12px;
    font-size: 14px;
    white-space: nowrap;
  }

  @media (max-width: 480px) {
    gap: 8px;

    .MuiButton-root {
      height: 40px;
      padding-inline: 8px;
      font-size: 12px;
    }
  }
`
